interface IconProps {
  fillColor: string
}

export const PinIntroIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        width="140"
        height="140"
        viewBox="0 0 140 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M51.8115 73.5905C52.5259 73.663 53.0827 74.2665 53.0827 75C53.0827 75.7335 52.5259 76.337 51.8115 76.4095L51.6667 76.416H43.3333C42.5509 76.416 41.9173 75.7824 41.9173 75C41.9173 74.2176 42.5509 73.584 43.3333 73.584H51.6667L51.8115 73.5905Z"
          fill={fillColor}
        />
        <path
          d="M66.8115 73.5905C67.5259 73.663 68.0827 74.2665 68.0827 75C68.0827 75.7335 67.5259 76.337 66.8115 76.4095L66.6667 76.416H58.3333C57.5509 76.416 56.9173 75.7824 56.9173 75C56.9173 74.2176 57.5509 73.584 58.3333 73.584H66.6667L66.8115 73.5905Z"
          fill={fillColor}
        />
        <path
          d="M81.8115 73.5905C82.5259 73.663 83.0827 74.2665 83.0827 75C83.0827 75.7335 82.5259 76.337 81.8115 76.4095L81.6667 76.416H73.3333C72.5509 76.416 71.9173 75.7824 71.9173 75C71.9173 74.2176 72.5509 73.584 73.3333 73.584H81.6667L81.8115 73.5905Z"
          fill={fillColor}
        />
        <path
          d="M96.8115 73.5905C97.5259 73.663 98.0827 74.2665 98.0827 75C98.0827 75.7335 97.5259 76.337 96.8115 76.4095L96.6667 76.416H88.3333C87.5509 76.416 86.9173 75.7824 86.9173 75C86.9173 74.2176 87.5509 73.584 88.3333 73.584H96.6667L96.8115 73.5905Z"
          fill={fillColor}
        />
        <path
          d="M99.4336 46.416C100.353 46.4165 101.1 47.1628 101.1 48.0827C101.1 49.0029 100.354 49.7489 99.4336 49.7493C98.5131 49.7493 97.7669 49.0032 97.7669 48.0827C97.7673 47.1625 98.5133 46.416 99.4336 46.416Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M101.667 38.584C105.21 38.584 108.083 41.4562 108.083 45V86.9173H111.042L111.336 86.932C112.786 87.0795 113.916 88.3033 113.916 89.7917C113.916 92.9903 111.324 95.5827 108.125 95.5827H31.875C28.6764 95.5827 26.084 92.9903 26.084 89.7917C26.084 88.2038 27.3705 86.9173 28.9583 86.9173H31.9173V45C31.9173 41.4562 34.7895 38.584 38.3333 38.584H101.667ZM28.9421 89.7526C28.9382 89.7543 28.9337 89.7577 28.929 89.7624C28.9244 89.767 28.921 89.7715 28.9193 89.7754C28.9193 89.7754 28.916 89.7833 28.916 89.7917C28.916 91.4255 30.2412 92.7506 31.875 92.7506H108.125C109.759 92.7506 111.084 91.4255 111.084 89.7917C111.084 89.7833 111.081 89.7754 111.081 89.7754C111.079 89.7715 111.076 89.767 111.071 89.7624C111.066 89.7577 111.062 89.7543 111.058 89.7526L111.042 89.7493H78.0599C78.0744 89.8307 78.0827 89.9144 78.0827 90C78.0827 90.7335 77.5259 91.337 76.8115 91.4095L76.6667 91.416H63.3333C62.5509 91.416 61.9173 90.7824 61.9173 90C61.9173 89.9143 61.9272 89.8308 61.9417 89.7493H28.9583C28.95 89.7493 28.9421 89.7526 28.9421 89.7526ZM38.3333 41.416C36.3543 41.416 34.7493 43.021 34.7493 45V86.9173H105.251V45C105.251 43.021 103.646 41.416 101.667 41.416H38.3333Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
